var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',_vm._b({staticClass:"form-control",class:{
    'is-invalid': _vm.hasError
  },attrs:{"rows":_vm.rows},domProps:{"value":_vm.$attrs.value},on:{"input":_vm.onInput}},'textarea',{
    maxlength: _vm.maxLength
  },false))
}
var staticRenderFns = []

export { render, staticRenderFns }